import React, {Component} from 'react';
import {Dimmer, Header, Loader} from 'semantic-ui-react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from 'recharts';

import ChartsData from "../../data/ChartsData";
import UpgradeAccount from "../extras/UpgradeAccount";
import localDB from "../../data/localDB";
import * as moment from "moment";
import {FormattedNumber} from "react-intl";

const CustomizedTick = (props) => {
    const {payload, x, y} = props;
    const cos = Math.cos(-payload.angle * Math.PI / 180);
    return (
        <text x={x} y={y} textAnchor={cos >= 0 ? 'start' : 'end'}>
            ${payload.value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}
        </text>
    );
};

class CustomTooltip extends React.Component {
    render() {
        const {active} = this.props;
        if (active) {
            // eslint-disable-next-line
            const {payload, label} = this.props;
            return (
                <div className="custom-tooltip">
                    <p className="label">{`${label} : $${payload[0].value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}`}</p>
                </div>
            );
        }
        return null;
    }
}

class LineChartCurrency extends Component {
    constructor(props) {
        super(props);
        this.state = {
            graphics_data: {
                total: 0,
                time: '',
                data: [
                    {label: '?', total: 0},
                    {label: '?', total: 0},
                ]
            },
            loading: true,
            time: null,
            date: new Date()
        }
    }

    async loadData(branch_office, time, date) {
        this.setState({loading:true, time, date});
        if (this.props.type === 'sales') {
            ChartsData.getSales(branch_office, time, date).then(sales_data =>{
                this.setState({graphics_data: sales_data, time});
                if(sales_data.hasOwnProperty('detail')){
                    this.setState({time, loading:false});
                }else{
                    this.setState({graphics_data: sales_data, time, loading:false});
                }
            });
        } else if (this.props.type === 'expenses') {
            ChartsData.getExpenses(branch_office, time, date).then(expenses_data =>{
                if(expenses_data.hasOwnProperty('detail')){
                    this.setState({time, loading:false});
                }else {
                    this.setState({graphics_data: expenses_data, time, loading:false});
                }
            });
        }
        else if (this.props.type === 'utilities') {
            ChartsData.getUtilities(branch_office, time, date).then(data =>{
                if(data.hasOwnProperty('detail')){
                    this.setState({time, loading:false});
                }else {
                    this.setState({graphics_data: data, time, loading:false});
                }
            });
        }
    };

    selectedDate = () =>{
        if(this.state.time === 'd'){
            return moment(new Date(this.state.date)).format("[-] dddd, MMMM D [de] YYYY");
        }else if(this.state.time === 'w'){
            return moment(new Date(this.state.date)).format("[-] [Semana] ww, MMMM [de] YYYY");
        }else if(this.state.time === 'm'){
            return moment(new Date(this.state.date)).format("[-] MMMM [de] YYYY");
        }else if(this.state.time === 'my'){
            return moment(new Date(this.state.date)).format("[- Año] YYYY");
        }else{
            return '';
        }
    };

    render() {
        return (
            <div>
                <div>
                    <Header sub>{`${this.props.title} ${this.selectedDate()}`}</Header>
                    <span>{
                        !localDB.checkPlanAccessExclude('reports_view_all') ?
                            // eslint-disable-next-line
                            <FormattedNumber value={this.state.graphics_data.total} currency="USD" style="currency" maximumFractionDigits={0} minimumFractionDigits={0}/>:null}
                    </span>
                </div>
                <Dimmer active={this.state.loading} inverted className='dimmer-charts'>
                    <Loader size='mini'>Cargando</Loader>
                </Dimmer>
                <ResponsiveContainer aspect={2}>
                    {!localDB.checkPlanAccessExclude('reports_view_all') || this.props.demo ?<LineChart data={this.state.graphics_data.data} syncId={this.props.id} margin={{
                        top: 10,
                        right: 30,
                        left: 10,
                        bottom: 0
                    }}>
                        <br/>
                        <XAxis dataKey="label"/>
                        <YAxis type='number' tick={CustomizedTick} />
                        <CartesianGrid strokeDasharray="3 3"/>
                        <Tooltip content={<CustomTooltip/>} />
                        <Line dataKey='total' stroke='#e44745' fill='#e44745'/>
                    </LineChart>:<UpgradeAccount message='este informe'/>}
                </ResponsiveContainer>
            </div>
        );
    }
}

export default LineChartCurrency;



// WEBPACK FOOTER //
// ./src/components/charts/LineChartCurrency.js